// Shared checkout-coupon presentation helpers for the unlock and Atlas checkout
// surfaces (PROMO_CODES_PLAN.md).
// Coupon discounts can land on non-round cents (percent codes); show them exactly.
export const fmtPriceExact = (cents) => cents % 100 === 0 ? `$${(cents / 100).toLocaleString()}` : `$${(cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
// Server-typed rejection reasons -> customer copy. The copy must say why, and
// "expired" states the date.
export const couponReasonCopy = (reason, expiresAt) => {
    switch (reason) {
        case 'expired':
            return expiresAt
                ? `This code expired on ${new Date(expiresAt * 1000).toLocaleDateString()}.`
                : 'This code has expired.';
        case 'already_used':
            return "You've already used this code on your account.";
        case 'limit_reached':
            return 'This code has reached its redemption limit.';
        case 'inactive':
            return 'This code is no longer active.';
        case 'not_applicable':
            return "This code isn't valid for this purchase.";
        default:
            return "We don't recognize that code. Check the spelling and try again.";
    }
};
